import { render, staticRenderFns } from "./FactoryTabs.vue?vue&type=template&id=17fd1c29&scoped=true&"
import script from "./FactoryTabs.vue?vue&type=script&lang=js&"
export * from "./FactoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./FactoryTabs.vue?vue&type=style&index=0&id=17fd1c29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fd1c29",
  null
  
)

export default component.exports